import { ProjectApi } from "@/types";
import logo from "@/assets/svgs/logo-full-green.svg";

interface ResolveBlogDetailsI {
  titleLength?: number;
}

export const resolveBlogDetails = (
  blog: ProjectApi.Blog.BlogData | undefined,
  options?: ResolveBlogDetailsI,
) => {
  const author = blog?.author || "";
  const authorUrl = blog?.authorUrl || logo;
  const title = blog?.title || "";
  const titleLength = options?.titleLength || 50;

  const shortenedTitle =
    title.length > titleLength ? `${title.slice(0, titleLength)}...` : title;
  const sprintAuthor = "Sprint Infrastructure";
  const authorText =
    author?.toLowerCase() === sprintAuthor.toLowerCase()
      ? "SendSprint"
      : author;

  return { authorText, authorUrl, title: shortenedTitle };
};
